module.exports = __webpack_public_path__ + "img/time-green.4e128975.svg";